export default __webpack_public_path__ + "static/media/down-circle-o.7fb1e160.svg";